<template>
  <v-text-field
      v-bind="$attrs"
      :value="value"
      dense
      outlined
      :clearable="clearable"
      @input="$emit('input', $event !== '' ? $event : null)"
      :error="error"
      :error-messages="error_message"
      append-icon="mdi-web"
      @click:append="onAppendClick(value)"
  >
  </v-text-field>
</template>

<script>

export default {
  name: 'BaseFieldLink',
  inheritAttrs: false,
  props: {
    value: {default: null},
    property_state: {default: null},
    property_state_field_name: {default: null},
    clearable: {default: false},
  },

  components: {},

  computed: {
    error() {
      return !!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error
    },
    error_message() {
      if (!!!!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error)
        return this.property_state[this.property_state_field_name].error_message
    else
      return null
    },
  },

  methods: {
    onAppendClick(link) {
      if (!!link)
        window.open(link, '_blank')
    }
  },

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
